import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Zap } from "lucide-react";

const CSWvsQuizMaker = () => {
  return (
    <ComparisonPageTemplate
      platformName="Quiz Maker"
      platformUrl="https://quiz-maker.com"
      seoTitle="CSW vs Quiz Maker"
      seoDescription="Compare CSW and Quiz-Maker.com for creating quizzes. Discover why CSW is the best Quiz Maker alternative with free unlimited quizzes and AI-powered features."
      seoKeywords="CSW vs Quiz Maker, Quiz Maker alternative, free quiz creator, online quiz builder, study tools"
      canonicalUrl="https://csw.live/quizzes/csw-vs-quiz-maker/"
      heroDescription="Looking for a simple quiz maker with a clean interface? Compare CSW and Quiz-Maker.com for your quiz creation needs."
      alternativeDescription="CSW provides a modern alternative to Quiz-Maker.com with AI-powered quiz generation, collaborative study rooms, and integrated learning tools—completely free."
      background="QuizMaker.com is a dedicated quiz platform that supports graded, scored and personality quizzes and offers unlimited quizzes and submissions on paid plans. It includes advanced features like question banks, randomization, timers, certificates and analytics."
      pros={[
        { text: "Wide variety of quiz types – Supports graded tests, personality quizzes and simple scored quizzes", source: "quiz-maker-review", sourceUrl: "https://quiz-maker-review.com" },
        { text: "Unlimited quizzes and submissions – Paid plans allow unlimited quizzes, questions and responses", source: "quiz-maker-review", sourceUrl: "https://quiz-maker-review.com" },
        { text: "Advanced features – Question banks, randomization, timers, leaderboards, certificates and integrations (Mailchimp, Zapier) provide comprehensive functionality", source: "quiz-maker-review", sourceUrl: "https://quiz-maker-review.com" },
        { text: "Strong analytics and reporting – Detailed stats and leaderboards help track performance", source: "quiz-maker-review", sourceUrl: "https://quiz-maker-review.com" },
      ]}
      cons={[
        { text: "No free plan – Only a trial is available" },
        { text: "Interface is functional but less modern and design‑focused than Typeform or Jebbit" },
        { text: "Limited customer support – Some users note that support response times could be improved" },
        { text: "Complexity may overwhelm casual users – The feature‑rich interface has a learning curve" },
      ]}
      cswFeatures={[
        { text: "AI quiz generation", available: true },
        { text: "Simple interface", available: true },
        { text: "Collaborative study", available: true },
        { text: "Flashcard support", available: true },
        { text: "Productivity tools", available: true },
        { text: "100% free", available: true },
      ]}
      competitorFeatures={[
        { text: "Simple interface", available: true },
        { text: "Free basic quizzes", available: true },
        { text: "Limited features", available: false },
        { text: "No AI generation", available: false },
        { text: "No study rooms", available: false },
        { text: "No flashcards", available: false },
      ]}
      benefits={[
        { icon: Brain, title: "AI-Powered", description: "Auto-generate quizzes from any content." },
        { icon: Users, title: "Collaborative", description: "Study and quiz with friends." },
        { icon: Zap, title: "Complete Platform", description: "Quizzes, flashcards, and more." },
      ]}
      forStudentsText="While Quiz-Maker.com offers basic quiz creation, CSW empowers educators and students alike with AI-powered content generation and collaborative learning spaces."
      pricingText="Quiz-Maker.com has no free plan; paid plans start at $25/month. CSW provides AI quiz generation, study rooms, and productivity tools completely free."
      competitorPrice="$25/mo+"
    />
  );
};

export default CSWvsQuizMaker;
